import axios, { Method } from 'axios';
import { KEY_ACCESS } from '@constants';
import { getLocalStorage } from '@helpers';
import { handleAxiosSuccess, handleAxiosError } from './utils';

type AxioService = {
  method: Method;
  apiPath: string;
  params?: any;
  data?: any;
};

export default async function axiosService({ method, apiPath, params, data }: AxioService) {
  const url = import.meta.env.VITE_BASE_API_URL + apiPath;
  const Authorization = 'Bearer ' + getLocalStorage(KEY_ACCESS);

  const headers = {
    ...(data instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    'Access-Control-Allow-Origin': 'Origin',
    Authorization,
  };

  const axiosConfig = {
    url,
    headers,
    method,
    params,
    data,
  };

  try {
    const response = await axios(axiosConfig);
    return handleAxiosSuccess(response);
  } catch (error) {
    return handleAxiosError({ method, apiPath, params, data, error });
  }
}
